module.exports = __webpack_public_path__ + "img/international.7afc2d1.svg";